/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownLeftIcon32Regular = forwardRef('ArrowDCornerDownLeftIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M22 21a5 5 0 0 0 5-5V4a1 1 0 1 0-2 0v12a3 3 0 0 1-3 3H6.414l7.293-7.293a1 1 0 1 0-1.414-1.414L4.955 17.63a3.35 3.35 0 0 0 0 4.738l7.338 7.338a1 1 0 0 0 1.414-1.414L6.414 21H22Z" })));
});
